<template>
  <v-row id="settingsOverview" class="detail-view-container">
    <SettingsInfoTabs />
  </v-row>
</template>

<script>
  import SettingsInfoTabs from "./SettingsInfoTabs";

  export default {
    name: "SettingOverview",

    components: {
      SettingsInfoTabs,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/GeneralSettings/SettingOverview.vue